import React, { useState } from 'react';
import { API_BASE } from '../config';

export default function AddressModal({ open, onClose, onSaved }) {
  const [line1, setLine1] = useState('');
  const [line2, setLine2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [postal, setPostal] = useState('');
  const [country, setCountry] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  if (!open) return null;

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/auth/address`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ line1, line2, city, state, postal_code: postal, country })
      });
      const data = await res.json();
      if (!res.ok) {
        if (data && data.error === 'address_incomplete') setError('Please fill at least street, postal code, and country.');
        else setError('Failed to save address.');
        return;
      }
      onSaved && onSaved(data.address);
      onClose && onClose();
    } catch (_) {
      setError('Network error. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: '#fff', borderRadius: 8, padding: 16, width: 420, boxShadow: '0 2px 10px rgba(0,0,0,0.2)' }}>
        <h3 style={{ marginTop: 0 }}>Complete your billing address</h3>
        <div style={{ display: 'grid', gap: 8 }}>
          <input placeholder="Street address" value={line1} onChange={(e)=>setLine1(e.target.value)} />
          <input placeholder="Address line 2 (optional)" value={line2} onChange={(e)=>setLine2(e.target.value)} />
          <div style={{ display: 'flex', gap: 8 }}>
            <input placeholder="City" value={city} onChange={(e)=>setCity(e.target.value)} style={{ flex: 1 }} />
            <input placeholder="State/Province" value={state} onChange={(e)=>setState(e.target.value)} style={{ flex: 1 }} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input placeholder="Postal code" value={postal} onChange={(e)=>setPostal(e.target.value)} style={{ flex: 1 }} />
            <input placeholder="Country (e.g., US, FR)" value={country} onChange={(e)=>setCountry(e.target.value)} style={{ flex: 1 }} />
          </div>
          {error && <div style={{ color: '#a33' }}>{error}</div>}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12, gap: 8 }}>
          <button className="btn" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="btn" onClick={save} disabled={saving}>Save</button>
        </div>
      </div>
    </div>
  );
}


